import { render } from "./AllProduct.vue?vue&type=template&id=9171e84c&scoped=true"
import script from "./AllProduct.vue?vue&type=script&lang=js"
export * from "./AllProduct.vue?vue&type=script&lang=js"

import "./AllProduct.vue?vue&type=style&index=0&id=9171e84c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9171e84c"]])

export default __exports__